import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyB3tUTs0PgYv4ADOZex1Wnu_R5BteWvhzM",
    authDomain: "elqanas-website.firebaseapp.com",
    projectId: "elqanas-website",
    storageBucket: "elqanas-website.appspot.com",
    messagingSenderId: "211750119095",
    appId: "1:211750119095:web:ca54b66d007ae182418f32"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export { firestore };